import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import CommunityGrid from './components/CommunityGrid';
import UnitTypes from './components/UnitTypes';
import InteriorSection from './components/InteriorSection';
import PricingSection from './components/PricingSection';
import ReservationSection from './components/ReservationSection';
import Testimonial from './components/Testimonial';
import Footer from './components/Footer';
import FloatingCTA from './components/FloatingCTA';
import PopupModal from './components/PopupModal';

export default function Home() {
  return (
    <main className="relative w-full overflow-x-hidden">
      <PopupModal />
      <Navbar />
      <Hero />
      <AboutSection />
      <CommunityGrid />
      <UnitTypes />
      <InteriorSection />
      <PricingSection />
      <Testimonial />
      <ReservationSection />
      <Footer />
      <FloatingCTA />
    </main>
  );
}